// Importación del nuevo archivo
import { FILE_EXPLORE_ROUTE_ACCESS, HELP_ROUTES_FILE_EXPLORE, combineRouteAccess, combineHelpRoutes } from './file-explorer.config.js';

export const ROUTE_ACCESS = {
  "/dashboard": ["Administrador", "vehicle", "thirdParty", "Recursos Humanos"],
  "/transport-calculator": [
    "Administrador",
    "vehicle",
    "thirdParty",
    "Recursos Humanos",
  ],
  "/validate-vehicle-inspection": [
    "Administrador",
    "vehicle",
    "thirdParty",
    "Recursos Humanos",
  ],
  "/location-reports": [
    "Administrador",
    "vehicle",
    "thirdParty",
    "Recursos Humanos",
  ],
  "/vehicle-tracking": [
    "Administrador",
    "vehicle",
    "thirdParty",
    "Recursos Humanos",
  ],
  "/transport-calculator/:id": [
    "Administrador",
    "vehicle",
    "thirdParty",
    "Recursos Humanos",
  ],
  "/agregar-info": ["Administrador", "vehicle"],
  "/reportes": ["Administrador"],
  "/perfil": ["Administrador", "vehicle", "thirdParty", "Recursos Humanos"],
  "/satellite-uploader": ["Administrador"],
  "/register": ["Administrador"],
  "/trends": ["Administrador"],
  "/hotspots": ["Administrador"],
  "/repeat-offenders": ["Administrador"],
  "/alerts-persons": ["Administrador", "Recursos Humanos"],
  "/geofences-travel-and-more": ["Administrador", "Recursos Humanos"],
  "/wssp-connection": ["Administrador"],
  "/persons": ["Administrador", "Recursos Humanos"],
  "/persons/administrators": ["Administrador", "Recursos Humanos"],
  "/persons/administrators/:cc": ["Administrador", "Recursos Humanos"],
  "/persons/setting/data": ["Administrador", "Recursos Humanos"],
  "/persons/operators": ["Administrador"],
  "/persons/operators/:cc": ["Administrador"],
  "/persons/ADO": ["Administrador", "Recursos Humanos"],
  "/persons/ADO/:id": ["Administrador", "Recursos Humanos"],
  "/persons/owners": ["Administrador", "Recursos Humanos"],
  '/persons/owner"': ["Administrador", "Recursos Humanos"],
  "/persons/third-parties": ["Administrador"],
  "/persons/third-parties/:cc": ["Administrador", "Recursos Humanos"],
  "/persons/RRHH": ["Administrador", "Recursos Humanos"],
  "/persons/RRHH/:cc": ["Administrador", "Recursos Humanos"],
  "/persons/add/user/:id": ["Administrador", "Recursos Humanos"],
  "/persons/profile/:id": ["Administrador", "Recursos Humanos"],
  "/vehicles": ["Administrador", "ADO"],
  "/alerts-vehicles": ["Administrador", "ADO", "vehicle"],
  "/vehicles/:id": ["Administrador", "ADO"],
  "/vehicles/update/:id": ["Administrador", "ADO"],
  "/vehicles/setting/data": ["Administrador", "ADO"],
  "/vehicles/owner/:id": ["Administrador", "ADO"],
  "/vehicles/add/vehicle": ["Administrador", "ADO"],
  "/vehicles/add/user/:id": ["Administrador", "ADO"],
  "/carriers": ["Administrador"],
  "/message": ["Administrador", "vehicle", "thirdParty"],

  //Rutas para JR
  "/scheduler": ["Administrador", "ADO", "Operador"],
  "/scheduler/ecopetrol": ["Administrador", "ADO", "Operador"],
  "/scheduler/gran-tierra-energy": ["Administrador", "ADO", "Operador"],
  "/scheduler/emerald-energy": ["Administrador", "ADO", "Operador"],
  "/scheduler/terpel-norte": ["Administrador", "ADO", "Operador"],
  "/scheduler/terpel-sur": ["Administrador", "ADO", "Operador"],
  "/operations/setting/data": ["Administrador"],
  
  // Rutas de Help (sin documentación)
  "/help": ["Administrador", "vehicle", "thirdParty", "Recursos Humanos"],
  "/help/tickets": ["Administrador", "ADO", "Operador"],
  "/help/privacy/accessibility": ["Administrador", "ADO", "Operador"],
  "/help/privacy/data-processing": ["Administrador", "ADO", "Operador"],
  "/help/privacy/terms-conditions": ["Administrador", "ADO", "Operador"],
  "/help/contact": ["Administrador", "ADO", "Operador"],
  "/help/tickets/department/:departmentId": ["Administrador", "Recursos Humanos"],
  "/help/privacy/information-protection": ["Administrador", "Recursos Humanos"],
};

// Combinación de rutas para uso completo
export const COMPLETE_ROUTE_ACCESS = combineRouteAccess(ROUTE_ACCESS, FILE_EXPLORE_ROUTE_ACCESS);

export const PERSON_ROUTES = {
  main: {
    path: "/persons",
    title: "Personas",
    subtitle: "Personas/",
  },
  administrators: {
    path: "/persons/administrators",
    title: "Administradores",
  },
  administrator: {
    path: "/persons/administrators/:cc",
    title: "Administrador",
    subtitle: "Personas/Administradores/{cc}",
  },
  operators: {
    path: "/persons/operators",
    title: "Operadores",
    subtitle: "Personas/Operadores",
  },
  operator: {
    path: "/persons/operators/:cc",
    title: "Operador",
    subtitle: "Personas/Operadores/{cc}",
  },
  ADOS: {
    path: "/persons/ADO",
    title: "Auxiliares de operaciones",
    subtitle: "Personas/Auxiliar de Operaciones",
  },
  ADO: {
    path: "/persons/ADO/:id",
    title: "Auxiliar de operaciones",
    subtitle: "Personas/Auxiliar de Operaciones/{id}",
  },
  owners: {
    path: "/persons/owners",
    title: "Propietarios",
    subtitle: "Personas/Propietarios",
  },
  owner: {
    path: "/persons/owners/:id",
    title: "Propietario",
    subtitle: "Personas/Propietarios/{id}",
  },
  thirdParties: {
    path: "/persons/third-parties",
    title: "Terceros",
    subtitle: "Personas/Terceros",
  },
  thirdParty: {
    path: "/persons/third-parties/:cc",
    title: "Tercero",
    subtitle: "Personas/Terceros/{cc}",
  },
  rrhh: {
    path: "/persons/RRHH",
    title: "Recursos Humanos",
    subtitle: "Personas/Recursos Humanos",
  },
  rrhhPerson: {
    path: "/persons/RRHH/:cc",
    title: "Recurso Humano",
    subtitle: "Personas/Recursos Humanos/{cc}",
  },
  addUser: {
    path: "/persons/add/user/:id",
    title: "Agregar Persona",
    subtitle: "Personas/{id}",
  },
  profile: {
    path: "/persons/profile/:id",
    title: "Perfil Persona",
    subtitle: "Personas/{id}",
  },
  setting: {
    path: "/persons/setting/data",
    title: "Configuracion de data",
    subtitle: "Personas/Configuración",
  },
};

export const VEHICLES_ROUTES = {
  main: {
    path: "/vehicles",
    title: "Vehiculos",
    subtitle: "Vehiculos",
  },
  vechicle: {
    path: "/vehicles/:id",
    title: "vehiculo",
    subtitle: "Vehiculos/{id}",
  },
  updated: {
    path: "/vehicles/update/:id",
    title: "Actulizar vehiculo",
    subtitle: "Vehiculos/{id}",
  },
  setting: {
    path: "/vehicles/setting/data",
    title: "Informacion requeridad para la creacion de un vehiculo",
    subtitle: "Vehiculos/Configuración",
  },
  add: {
    path: "/vehicles/add/vehicle",
    title: "Agregar vehiculo",
    subtitle: "Vehiculos/Agregar vehiculos",
  },
  addOwner: {
    path: "/vehicles/add/user/:id",
    title: "Agregar Propietario vehicular",
    subtitle: "Vehiculos/{id}",
  },
  owner: {
    path: "/vehicles/owner/:id",
    title: "Propietario vehicular",
    subtitle: "Vehiculos/Configuración/{id}",
  },
};

export const ROUTES = {
  Administrador: {
    dashboard: "/dashboard",
    agregarInfo: "/agregar-info",
    reportes: "/reportes",
    perfil: "/perfil",
    persons: "/persons",
    satellite: "/satellite-uploader",
    register: "/register",
    trends: "/trends",
    hotspots: "/hotspots",
    repeatOffenders: "/repeat-offenders",
    users: "/users",
    vehicles: "/vehicles",
    carriers: "/carriers",
    message: "/message",
  },
  vehicle: {
    dashboard: "/dashboard",
    agregarInfo: "/agregar-info",
    perfil: "/perfil",
  },
  thirdParty: {
    dashboard: "/dashboard",
    perfil: "/perfil",
  },
};

export const OPERATIONS_ROUTES = {
  main: {
    path: "/scheduler",
    title: "Operaciones",
    subtitle: "Operaciones/",
  },
  ecopetrol: {
    path: "/scheduler/ecopetrol",
    title: "Ecopetrol",
    subtitle: "Operaciones/Ecopetrol",
  },
  granTierra: {
    path: "/scheduler/gran-tierra-energy",
    title: "Gran Tierra Energy",
    subtitle: "Operaciones/Gran Tierra Energy",
  },
  emerald: {
    path: "/scheduler/emerald-energy",
    title: "Emerald Energy",
    subtitle: "Operaciones/Emerald Energy",
  },
  terpelNorte: {
    path: "/scheduler/terpel-norte",
    title: "Terpel Norte",
    subtitle: "Operaciones/Terpel Norte",
  },
  terpelSur: {
    path: "/scheduler/terpel-sur",
    title: "Terpel Sur",
    subtitle: "Operaciones/Terpel Sur",
  },
  setting: {
    path: "/scheduler/setting/data",
    title: "Configuración de datos",
    subtitle: "Operaciones/Configuración",
  },
};

// HELP_ROUTES sin las rutas de documentación
export const HELP_ROUTES = {
  main: {
    path: "/help",
    title: "Centro de Ayuda",
    subtitle: "Centro de Ayuda/",
    category: "main"
  },
  tickets: {
    path: "/help/tickets",
    title: "Tickets",
    subtitle: "Centro de Ayuda/Tickets",
    category: "main"
  },
  ticketDepartment: {
    path: "/help/tickets/department/:departmentId",
    title: "Departamento de Tickets",
    subtitle: "Centro de Ayuda/Gestión de Tickets/Departamento",
    category: "main",
    parent: "Tickets"
  },
  // Privacidad y tratamiento de datos
  accessibility: {
    path: "/help/privacy/accessibility",
    title: "Declaración de accesibilidad",
    subtitle: "Centro de Ayuda/Privacidad/Declaración de accesibilidad",
    category: "privacy",
    parent: "Privacidad y tratamiento de datos"
  },
  dataProcessing: {
    path: "/help/privacy/data-processing",
    title: "Privacidad y tratamiento de datos",
    subtitle: "Centro de Ayuda/Privacidad/Privacidad y tratamiento de datos",
    category: "privacy",
    parent: "Privacidad y tratamiento de datos"
  },
  termsConditions: {
    path: "/help/privacy/terms-conditions",
    title: "Términos y condiciones de uso",
    subtitle: "Centro de Ayuda/Privacidad/Términos y condiciones de uso",
    category: "privacy",
    parent: "Privacidad y tratamiento de datos"
  },
  informationProtection: {
    path: "/help/privacy/information-protection",
    title: "Guía del Sistema de Protección de la Información",
    subtitle: "Centro de Ayuda/Privacidad/Sistema de Protección de la Información",
    category: "privacy",
    parent: "Privacidad y tratamiento de datos"
  },
  // Contacto
  contact: {
    path: "/help/contact",
    title: "Contacto",
    subtitle: "Centro de Ayuda/Contacto",
    category: "main"
  }
};

// Combinación de rutas help completas
export const COMPLETE_HELP_ROUTES = combineHelpRoutes(HELP_ROUTES, HELP_ROUTES_FILE_EXPLORE);